import * as Api from '@ViewModels';

/** Group follow-ups read every campaign in the send, which only admins who can send on behalf may do. */
export function canFollowUpCampaignGroup(
	userSession: Api.UserSessionContext,
	campaign?: Pick<Api.ICampaign, 'groupId'>
) {
	return !!campaign?.groupId && !!userSession.isAdmin && !!userSession.canSendOnBehalf;
}

export function getCampaignGroupFollowUpPath(campaignId: string) {
	return `/email/campaigns/create/campaign-group-follow-up/${encodeURIComponent(campaignId)}`;
}
